import { mediaTypes } from './constants';

export const transformIframeUrl = (url) => {
  const secureUrl = url.replace('http://', 'https://');
  if (secureUrl.includes('youtube')) {
    const qsParams = url.split(/[?&#]/);
    let videoId = '';
    // skip the url itself
    for (let i = 1; i < qsParams.length; i += 1) {
      const parts = qsParams[i].split('=');
      /* istanbul ignore else */
      if (parts[0] === 'v') {
        videoId = parts[1];
        break;
      }
    }
    return `https://www.youtube.com/embed/${videoId}`;
  }
  if (secureUrl.includes('vimeo'))
    return secureUrl.replace('vimeo.com', 'player.vimeo.com/video');
  return secureUrl;
};

export const isValidMedia = (mediaElement) => {
  let isValid =
    !!mediaElement &&
    !!mediaElement.media_type &&
    (mediaElement.media_type === mediaTypes.IMAGE_URL ||
      mediaElement.media_type === mediaTypes.IMAGE_S3 ||
      mediaElement.media_type === mediaTypes.VIDEO_URL);

  if (isValid && mediaElement.media_type === mediaTypes.IMAGE_S3) {
    isValid = !!mediaElement.media_url;
  }

  return isValid;
};

export const fetchVimeoThumbnail = (media_url) => {
  let vimeoId = '';
  try {
    vimeoId = new URL(media_url).pathname.replace(/\//, '');
  } catch (_) {
    return media_url;
  }

  const vimeoUrl = `https://vimeo.com/api/v2/video/${vimeoId}.json`;

  return fetch(vimeoUrl)
    .then((response) => response.json())
    .then((response) => {
      const imageUrls =
        Array.isArray(response) && response.length > 0 ? response[0] : response;

      if (imageUrls.thumbnail_large && imageUrls.thumbnail_large !== '') {
        return imageUrls.thumbnail_large;
      } else if (imageUrls.thumbnail_medium && imageUrls.thumbnail_medium !== '') {
        return imageUrls.thumbnail_medium;
      } else if (imageUrls.thumbnail_small && imageUrls.thumbnail_small !== '') {
        return imageUrls.thumbnail_small;
      }

      return media_url;
    });
};

export const decorateAssetsWithThumbnails = async (media) => {
  return new Promise((resolve) => {
    let clones = media.map((asset) => ({
      ...asset,
    }));
    let fetchCount = 0;

    clones.forEach((clone) => {
      if (
        clone.media_type === mediaTypes.VIDEO_URL &&
        (typeof clone.media_url === 'string') & (clone.media_url.length > 0)
      ) {
        if (clone.media_url.includes('vimeo.com')) {
          fetchCount = fetchCount + 1;

          fetchVimeoThumbnail(clone.media_url).then((resp) => {
            clone.thumbnail = resp;
            fetchCount = fetchCount - 1;

            if (fetchCount === 0) {
              resolve(clones);
            }
          });
        } else {
          let videoId = '';
          try {
            videoId = new URL(clone.media_url).searchParams.get('v');
          } catch (_) {
            videoId = '';
          }
          clone.thumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
        }
      }
    });

    if (fetchCount === 0) {
      resolve(clones);
    }
  });
};
